import React from "react";
import { PALETTE } from "../../common/ThemeConstants";
import { getRequest } from "../../api/axiosRequests";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useEffect, useState } from "react";

import { FaEdit } from "react-icons/fa";
import { IoClose } from 'react-icons/io5'

export default function CardAdminWorkoutExercise({
  workoutExercise,
  height = 75,
  editCallback,
  onDeleteButtonClicked,
}) {
  const [exercise, setExercise] = useState({ id: -1, name: "", cover: "" });

  async function fetchExercise() {
    try {
      const headers = { Authorization: localStorage.getItem("jwt") };
      const response = await getRequest(
        "exercise/" + workoutExercise.exercise,
        headers
      );
      setExercise(response.data);
    } catch (err) { }
  }

  useEffect(() => {
    fetchExercise();
  }, []);

  return (
    <div
      className="my-2 shadow-sm rounded-md"
      style={{ border: "solid 0px", backgroundColor: PALETTE.WHITE }}
    >
      <Row className="g-0 align-items-center">
        <Col xs={4} className="align-self-center text-start p-1">
          <img
            className="rounded-md"
            style={{
              objectFit: "cover",
              height: height,
              width: height,
            }}
            src={exercise.cover}
            alt={exercise.name}
          />
        </Col>
        <Col xs={6} className="text-start" style={{ paddingLeft: "4px" }}>
          <p style={{ marginBottom: "2px" }}>{exercise.name}</p>
          {workoutExercise.weight > 0 && (
            <p
              className="mb-0 cardIconText"
              style={{ color: PALETTE.DARKGRAY }}
            >
              {" "}
              Weight: {workoutExercise.weight} (KG)
            </p>
          )}
          {workoutExercise.repetitions > 0 && (
            <p
              className="mb-0 cardIconText"
              style={{ color: PALETTE.DARKGRAY }}
            >
              {" "}
              Repeat: {workoutExercise.repetitions} times{" "}
            </p>
          )}
          {workoutExercise.duration > 0 && (
            <p
              className="mb-0 cardIconText"
              style={{ color: PALETTE.DARKGRAY }}
            >
              {" "}
              Hold: {workoutExercise.duration}''
            </p>
          )}
          {workoutExercise.rest > 0 && (
            <p
              className="mb-0 cardIconText"
              style={{ color: PALETTE.DARKGRAY }}
            >
              {" "}
              Rest: {workoutExercise.rest}''
            </p>
          )}
        </Col>
        <Col xs={1} className="align-self-center text-center">
          <FaEdit
            size={20}
            color={PALETTE.GRAY}
            style={{ cursor: "pointer" }}
            onClick={() => {
              editCallback(workoutExercise.id);
            }}
          />
        </Col>
        <Col xs={1} className="align-self-center text-center">
          <IoClose
            size={20}
            color={PALETTE.GRAY}
            style={{ cursor: "pointer" }}
            onClick={onDeleteButtonClicked}
          />
        </Col>
      </Row>
    </div>
  );
}
